import { render, staticRenderFns } from "./product-data.vue?vue&type=template&id=1224ec68&scoped=true&"
import script from "./product-data.vue?vue&type=script&lang=js&"
export * from "./product-data.vue?vue&type=script&lang=js&"
import style0 from "./product-data.vue?vue&type=style&index=0&id=1224ec68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224ec68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1224ec68')) {
      api.createRecord('1224ec68', component.options)
    } else {
      api.reload('1224ec68', component.options)
    }
    module.hot.accept("./product-data.vue?vue&type=template&id=1224ec68&scoped=true&", function () {
      api.rerender('1224ec68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/product-data.vue"
export default component.exports